module.exports = __webpack_public_path__ + "static/media/31.e44a954.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/31.wav
// module id = 5+UO
// module chunks = 0